import { cn, Field, SelectControl, statusFilterProps } from "@quortex/front-common"
import { type MakeGenerics, useNavigate } from "@tanstack/react-location"
import { isEmpty } from "lodash-es"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

export type StatusFilterProps = {
  statusList: string[]
  statusCount?: Record<string, number>
  className?: string
  onChange?: (statusList: string[]) => void
}

export type StatusFilterData = { statusFilterList: string[] }
export type StatusFilterSearch = Partial<StatusFilterData>

const StatusFilter: FC<StatusFilterProps> = ({ statusList, statusCount, className, onChange }) => {
  const form = useFormContext<StatusFilterData>()
  const navigate = useNavigate<MakeGenerics<{ Search: StatusFilterSearch }>>()

  const handleChange = (newStatusList: string[]) => {
    onChange?.(newStatusList)
    form.setValue("statusFilterList", newStatusList)
    navigate({
      search: old => ({
        ...old,
        statusFilterList: isEmpty(newStatusList) ? undefined : newStatusList
      })
    })
  }

  return (
    <Field
      className={cn("min-w-[7.875rem] push-sidebar:min-w-[10rem] max-w-[15.5rem]", className)}
      name="statusFilterList"
    >
      {name => (
        <Controller
          control={form.control}
          name={name}
          render={({ field }) => (
            <SelectControl
              {...field}
              autoWidthMenu
              data-testid="status-filter"
              isMulti
              maxVisible={2}
              options={statusList.map(status => ({
                label: status,
                value: status
              }))}
              placeholder="Status"
              onChange={handleChange}
              {...statusFilterProps(statusCount ?? {})}
            />
          )}
        />
      )}
    </Field>
  )
}

export default StatusFilter
